












export default {
  name: "PDFViewer",
  props: {
    fileURL: {
      type: String,
      required: true
    },
    viewerRules: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    rules() {
      const params = new URLSearchParams({ zoom: "100", ...this.viewerRules });
      return params.toString();
    }
  }
};
